import {
  Box,
  Grid2,
  Typography,
  useTheme
} from '@mui/material';
import React, { FC, useEffect, useMemo, useState } from 'react';

import { FaArrowCircleLeft } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import ChangeDueDateButton from '../../../Components/ChangeDueDateButton/change-due-date-button.component';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { Flex } from '../../../Components/Flex/flex.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { ButtonStepMenu } from '../../../Components/Form/ButtonStepMenu/button-step-menu.component';
import InputCalendar from '../../../Components/Form/InputCalendar/input-calendar.component';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import LinkClipBoard from '../../../Components/LinkClipBoard/link-clip-board.component';
import { Table } from '../../../Components/Table/table.component';
import { Tag } from '../../../Components/Tag/tag.component';
import { ServiceOrderStageEnum, ServiceOrderStatusEnum } from '../../../Services/api/service-orders/service-order.interface';
import { ListServiceOrdersUseCase } from '../../../Usecase/ServiceOrders/list-service-orders-usecase';
import { ShowServiceOrdersUseCase } from '../../../Usecase/ServiceOrders/show-service-orders-usecase';
import { UpdateServiceOrdersUseCase } from '../../../Usecase/ServiceOrders/update-service-orders-usecase';
import { labelsOrderProductionStage, normalizeOrderProductionStage } from '../../../utils/normalizeProductionStages';
import { useProductionDetails } from './production-details.hook';
import { Loader } from '../../../Components/Loader';
import { Can } from '../../../Components/Can';

interface IProductionDetailsProps {
    listServiceOrdersUseCase: ListServiceOrdersUseCase
  showServiceOrdersUseCase: ShowServiceOrdersUseCase
  updateServiceOrdersUseCase: UpdateServiceOrdersUseCase
 
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

const ProductionDetails : FC<IProductionDetailsProps> = ({ listServiceOrdersUseCase, showServiceOrdersUseCase, updateServiceOrdersUseCase}) => {
    const [value, setValue] = React.useState(0);
    const [showConfirmation, setShowConfirmation] = useState(false)
    const params = useParams()
    const navigate = useNavigate()
   
    const [tabIndex, setTabIndex] = useState(0);
    const theme = useTheme()

  const { handleShowOrderDetails, orderDetails, handleConfirmProductionItems, register, control, errors, optionsProductionStage, loading, list  } = useProductionDetails({
    listServiceOrdersUseCase, showServiceOrdersUseCase, updateServiceOrdersUseCase, osId: String(params?.osId)
  })

  const handleConfirmItems = (data: { status: ServiceOrderStatusEnum | ServiceOrderStageEnum, productId: string }) => {
    handleConfirmProductionItems({ ...data, status: data.status as ServiceOrderStatusEnum })
  }

 

  const columns = useMemo(() => {
    const createColumns: any[] = [    
      {
        field: 'code',
        headerName: 'Cód. Personalização',
        width: 170,
        renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Typography color={params.row.status === ServiceOrderStatusEnum.PRODUCED ? theme.palette.grey[500] : '#000' }>{`${params?.row?.id}`}</Typography></Box>
      },
      {
        field: 'nsOrderId',
        headerName: 'Pedido Nuvem',
        width: 160,
        renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Typography color={params.row.status === ServiceOrderStatusEnum.PRODUCED ? theme.palette.grey[500] : '#000' }>{params?.row?.order?.nsOrderId}</Typography></Box>
      },
      {
        field: 'description',
        headerName: 'Produto',
        flex:1,
        renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', whiteSpace: "normal",  
          wordBreak: "break-word", 
          overflowWrap: "break-word", }}><Typography color={params.row.status === ServiceOrderStatusEnum.PRODUCED ? theme.palette.grey[500] : '#000' } fontSize={'14px'}>{String(params?.row?.product?.name).toUpperCase()}</Typography></Box>
      },
      {
        field: 'quantity',
        headerName: 'Tiragem',
        width: 100,
      },
      {
        field: 'card',
        headerName: 'Aprovação da Arte',
        width:140,
        align: 'center',
        renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Typography>10/02/2025</Typography></Box>
      },
      {
        field: 'art_link',
        headerName: 'Link da Arte',
        headerAlign: 'center',
        width: 100,
        align: 'center',
        renderCell: (params: any) => <Flex justifyContent='center' alignItems='center' width={'100%'} height={'100%'}><LinkClipBoard link={params?.row?.artLink} /></Flex> 
      },
      {
        field: 'productionDueDate',
        headerName: 'Prazo',
        headerAlign: 'center',
        width:190,
        renderCell: (params: any) => <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}><Tag title={params?.row?.productionDueDate} boxStyle={{ backgroundColor: 'rgba(76, 175, 80, 0.5)' }} titleStyle={{ color: '#000', fontSize: '17px', fontWeight: '400' }} /></Box>
      },
      {
        field: 'due_date',
        headerName: 'Novo Prazo',
        headerAlign: 'center',
        width: 200,
        renderCell: (params: any) => <Flex gap='25px' alignItems='center'>
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center'}}>Não informado</Box>
            <ChangeDueDateButton onSubmit={async () => {}}/>
          </Flex>
      },
      
      {
        field: 'actions',
        headerName: 'Etapa',
        headerAlign: 'center',
        width: 250,
        // renderCell: (params: any) => (
        //   <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        //     <ColorfulSelect
        //       label="Etapa"
        //       options={optionsProduction}
        //       control={control}
        //       error={!!errors.tributaryRegime}
        //       helperText={errors?.tributaryRegime?.message || ''}
        //       placeholder=""
        //       {...register(`step-product-${params.row.id}`)}
        //       sx={{ width: '100%' }} // Garante que o Select ocupe toda a largura disponível
        //     />
        //   </Box>
        // ),
        renderCell: (params: any) => <ButtonStepMenu type='stage' options={optionsProductionStage} initialLabel={labelsOrderProductionStage[params.row.status as ServiceOrderStageEnum]} onChange={handleConfirmItems} serviceOrderProductId={params.row.id} initialValue={params.row.status as ServiceOrderStageEnum} />
        
      }
    ];
  
    return createColumns;
  }, [optionsProductionStage, orderDetails]);


  const handleConfirmation = () => {
    setShowConfirmation(false)
  }

  useEffect(() => {
    if(params?.osId){
        handleShowOrderDetails(params.osId)
    }
    
  }, [params])
  
  

  return (
    <Can permissions={['menu:production:manage']}>  
    {loading && <Loader />}
  
    <ConfirmDialog open={showConfirmation}  title='Marcar como item produzido' description='Você tem certeza?' onCancel={() => setShowConfirmation(false)} onConfirm={handleConfirmation} />

    <Grid2 container>
      
        <Grid2 size={12} sx={{ padding: '20px'}}>
            <Flex alignItems='center' justifyContent='space-between'>
              <Flex alignItems='center'>
                <Button variant='text' sx={{ width: '50px', marginTop: '5px'}} onClick={() => navigate('/production-list')}><FaArrowCircleLeft size={25} /></Button>
                <Typography sx={{ fontSize: '19px', fontWeight: 600}}>Ordem de Produção (OP) - #{orderDetails?.externalProductionId}</Typography>
              </Flex>

              <Flex  gap='20px' marginLeft='50px' >
                <Box>
                  <Typography sx={{ fontSize: '15px', marginBottom: '10px'}}>Alterar etapa de todos os itens da OS</Typography>
                  <SelectComponent 
                      label='Etapa' 
                      options={optionsProductionStage} 
                      control={control} 
                      error={!!errors.tributaryRegime} 
                      helperText={errors?.tributaryRegime?.message || ''} 
                      placeholder=''
                      {...register('step')} 
                  />
                </Box>

                <Box>
                  <Typography sx={{ fontSize: '15px', marginBottom: '10px'}}>Adicionar novo prazo para todos os itens da OP</Typography>
                  <Flex alignItems='center'>
                    <InputCalendar />
                    <Button type="submit" sx={{  width: '200px', height: '55px', marginLeft: '15px' }}>
                        SALVAR
                    </Button>
                  </Flex> 
                </Box>
               

               
              </Flex>
                
            </Flex> 
        </Grid2>
 
        <Grid2 size={12} sx={{ padding: '20px', paddingTop: 0}}>
            {!!orderDetails?.id &&  <Table 
              disableRowSelectionOnClick={false} 
              data={orderDetails?.products} 
              totalCount={0} 
              columns={columns} 
              sx={{ minHeight: '91%', with: '100%'}} 
              isRowSelectable={() => false}
              // onSelect={(e: any) => handleConfirmProductionItems(e)} 
              // onRowClick={(e: any) => handleConfirmProductionItems(e)} 
              // isRowSelectable={(params: any) => params.row.status !== ServiceOrderStatusEnum.PRODUCED} 
             />}
        </Grid2>
    </Grid2>

   

   

    </Can>
  );
};

export default ProductionDetails;
